import React from "react";
import CompanyDetails from "./CompanyDetails";

const CompanyPage = () => {
  return <CompanyDetails />;
};

export default CompanyPage;
